import * as React from "react";
import { useContext, useEffect, useState } from "react";
import { MyNumberInputTemplateProps } from "@graffer-inc/form-generator";
import { reportAsyncError } from "@graffer-inc/smart-apply";
import { MyNumberRawValue } from "@graffer-inc/form-schema";
import { BaseTypeLiterals } from "../../../../application/domain/base/base-type";
import { FormContext } from "@graffer-inc/form-generator";

type ViewInputStateLiterals = "NO_VALUE" | "DECRYPTED" | "REFKEY";

type Matcher<R> = BaseTypeLiterals<ViewInputStateLiterals, R>;

function matchState<T>(
  value: string | undefined,
  rawValue: MyNumberRawValue | undefined,
  decrypted: string | undefined,
  matcher: Matcher<T>,
) {
  if (decrypted !== undefined) {
    return matcher["DECRYPTED"];
  }
  if (rawValue === undefined || value === undefined) {
    return matcher["NO_VALUE"];
  }
  return matcher["REFKEY"];
}

export const MyNumberViewInput: React.FC<MyNumberInputTemplateProps> = ({
  config,
  value,
}) => {
  const {
    refKeyContext: { myNumberRefKeyExchanger },
  } = useContext(FormContext);

  const [rawValue, setRawValue] = useState<MyNumberRawValue | undefined>(
    value !== undefined && value !== ""
      ? myNumberRefKeyExchanger?.refkeyToValue(value)
      : undefined,
  );

  const [decrypted, setDecrypted] = useState<string | undefined>();

  const requestDecrypt = React.useCallback(async () => {
    try {
      const myNumber = await (rawValue as any).requestDecrypt();
      setDecrypted(myNumber);
    } catch (e) {
      reportAsyncError(e);
    }
  }, [setDecrypted, rawValue]);

  useEffect(() => {
    if (value !== undefined && value !== "") {
      setRawValue(myNumberRefKeyExchanger?.refkeyToValue(value));
    }
  }, [myNumberRefKeyExchanger, value]);

  return (
    <p data-elem-id={config.formFieldId}>
      {matchState(value, rawValue, decrypted, {
        DECRYPTED: <>{decrypted}</>,
        NO_VALUE: null,
        REFKEY: (
          <>
            ************{" "}
            <span className="icon c-hoverable" onClick={requestDecrypt}>
              <i className="fas fa-eye-slash" />
            </span>
          </>
        ),
      })}
    </p>
  );
};
